import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import { useRouter } from 'vue-router/composables'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'
  import useDuration from '@/composables/useDuration'
  import useSegment from '@/composables/useSegment'
  import useGamification from '@/composables/useGamification'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useCommonMixin from '@/composables/useCommonMixin'

  import CourseApi from '@/services/api/CourseApi'

  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  import * as Sentry from '@sentry/vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaufiUpsell',
  setup(__props) {

  const router = useRouter()

  const { baufiUpsellImage, crownIcon, arrowRightIndicator, mediaIcon } = useIcons()
  const { course, nextEnabledModule, navigateToModule, navigateToCourseContent } = useCourse()
  const { translateString } = useI18n()
  const { formatDurationToHHMM } = useDuration()
  const { frontendCourseTrialStarted } = useSegment()
  const { trackGamificationActivity } = useGamification()
  const { handleShopifyCheckout } = useShopifyClient()
  const { hasValidUser } = useCommonMixin()

  const loadingNextAction = ref(false)
  const loadingCheckout = ref(false)

  const baufiCourseDetails = computed(() => {
    return course.value?.baufiCourseDetails
  })

  const contentDetails = computed(() => {
    return `${baufiCourseDetails.value?.numberOfLessons} ${translateString('courses.lessons')}, ${formatDurationToHHMM(baufiCourseDetails.value?.duration || 0)}h ${translateString('contents')}`
  })

  const nextModule = computed(() => {
    return nextEnabledModule.value(baufiCourseDetails.value!.id)
  })

  const nextLesson = computed(() => {
    return nextModule.value?.lessons.find((lesson) => !lesson.completed) || nextModule.value?.lessons[0]
  })

  const resetCurrentCourse = () => {
    CourseModule.setCourse(null)
  }

  const handleUpsellButtonClick = async () => {
    if (!hasValidUser.value) {
      router.push('/login')
      return
    }

    if (baufiCourseDetails.value?.purchased) {
      resetCurrentCourse()
      navigateToCourseContent(nextModule.value, nextLesson.value || null, baufiCourseDetails.value!.id, false)
    } else if (baufiCourseDetails.value?.trial) {
      resetCurrentCourse()
      navigateToModule(baufiCourseDetails.value!.id, nextModule.value, nextLesson.value || null)
    } else {
      await startTrialAndNavigateToModule()
    }
  }

  const startTrialAndNavigateToModule = async () => {
    loadingNextAction.value = true
    try {
      await CourseApi.startCourseTrial([baufiCourseDetails.value!.id])
      resetCurrentCourse()
      navigateToModule(baufiCourseDetails.value!.id, nextModule.value, nextLesson.value || null)

      frontendCourseTrialStarted(UserModule.email, baufiCourseDetails.value!.id, baufiCourseDetails.value?.title || '')
      trackGamificationActivity('COURSE_TRIAL_STARTED', {
        courseId: baufiCourseDetails.value!.id,
        moduleId: null,
        lessonId: null,
      })
      CourseModule.setBaufiCourseTrialStatus(true)
    } catch (error) {
      Sentry.captureException(error)
    } finally {
      loadingNextAction.value = false
    }
  }

  const fetchBaufiCourseModules = async () => {
    const courseModules = CourseModule.coursesModuleMap[baufiCourseDetails.value!.id]

    if (courseModules === undefined) {
      CourseModule.getCourseModules(baufiCourseDetails.value!.id)
    }
  }

  const handleCheckout = async (variantId: string, email: string) => {
    loadingCheckout.value = true
    await handleShopifyCheckout(variantId, email)
    setTimeout(() => {
      loadingCheckout.value = false
    }, 200)
  }

  onMounted(() => {
    fetchBaufiCourseModules()
  })

return { __sfc: true,router, baufiUpsellImage, crownIcon, arrowRightIndicator, mediaIcon, course, nextEnabledModule, navigateToModule, navigateToCourseContent, translateString, formatDurationToHHMM, frontendCourseTrialStarted, trackGamificationActivity, handleShopifyCheckout, hasValidUser, loadingNextAction, loadingCheckout, baufiCourseDetails, contentDetails, nextModule, nextLesson, resetCurrentCourse, handleUpsellButtonClick, startTrialAndNavigateToModule, fetchBaufiCourseModules, handleCheckout, computed, ref, onMounted, SVGRenderer, KetchUpButton, LoadingSpinner, useRouter, useIcons, useCourse, useI18n, useDuration, useSegment, useGamification, useShopifyClient, useCommonMixin, CourseApi, UserModule, CourseModule, Sentry }
}

})